import { ReportProblemButton } from '@app/components/ReportProblem'
import { ContactEmail } from '@app/components/site'
import { ApiRequestError } from '@app/lib/api'
import { signInUrl } from '@app/lib/auth'
import {
  canReloadForNewVersion,
  describeError,
  isChunkLoadError,
  OUR_FAULT,
  reloadForNewVersion,
} from '@app/lib/errors'
import { useEffect, useState } from 'react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

export function RootErrorBoundary() {
  const error = useRouteError()
  const is404 = isRouteErrorResponse(error) && error.status === 404
  // A new version was deployed and this page asked for a file that's gone: reload once to get
  // the new version. If that already happened (the reload didn't help), say so instead.
  const chunk = isChunkLoadError(error)
  const [reloading] = useState(() => chunk && canReloadForNewVersion())
  useEffect(() => {
    if (reloading) reloadForNewVersion()
  }, [reloading])
  if (reloading)
    return (
      <main className="container container--narrow" style={{ paddingBlock: '4rem' }}>
        <p role="status">Updating to the latest version…</p>
      </main>
    )
  // API errors have a plain-language version; anything else that reaches here is our bug.
  const info = error instanceof ApiRequestError ? describeError(error) : null
  return (
    <main className="container container--narrow" style={{ paddingBlock: '4rem' }}>
      <h1>{is404 ? 'Page not found' : 'Something went wrong'}</h1>
      <p className="muted">
        {is404 ? 'We couldn’t find that page.' : (info?.message ?? OUR_FAULT)}
        {info?.signedOut ? (
          <>
            {' '}
            <a href={signInUrl()}>Sign in again</a>
          </>
        ) : null}
      </p>
      <div className="cluster">
        <Link className="btn" to="/">
          Go home
        </Link>
        <button
          type="button"
          className="btn btn--secondary"
          onClick={() => window.location.reload()}
        >
          {is404 ? 'Reload' : 'Try again'}
        </button>
      </div>
      <p className="small muted">
        If this keeps happening, email <ContactEmail /> or{' '}
        <ReportProblemButton error={error} label="report a problem" />.
      </p>
    </main>
  )
}
